var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Divider',{ref:"elementRef",class:this.props.className,style:(this.props.style),attrs:{"type":this.props.type,"orientation":this.props.orientation,"dashed":this.props.dashed,"size":this.props.size}},[(_vm.text)?_c('div',{staticClass:"dividerText"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b7f9462","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/DividerComponent.vue
// module id = null
// module chunks = 